export const to2Decimals = num => {
    try {
        const nans = ["nan", "NaN", "infinity", "Infinity"];
        if (nans.includes(num)) {
            return 0.0;
        }
        let numero = Number.parseFloat(num).toFixed(2);
        return nans.includes(numero) ? num : numero;
    } catch (e) {
        return num;
    }
};
